import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { greetingHref } from "@/lib/services";
import { useServices } from "@/context/ServicesContext";

export const WhatsAppButton = ({ phone, who, testid, compact = false, href: custom }) => {
  const { company, messaging } = useServices();
  const href = custom !== undefined ? custom : greetingHref(phone, who, company, messaging?.greeting_template);
  const label = compact ? null : <span className="ml-1">WhatsApp</span>;
  const cls = compact ? "h-8 w-8 rounded-full p-0" : "rounded-full";
  if (!href) {
    return (
      <Button type="button" size="sm" variant="outline" disabled title="Cadastre o telefone do cliente" className={`${cls} border-slate-700 bg-transparent`} data-testid={testid}>
        <MessageCircle className="h-4 w-4" />{label}
      </Button>
    );
  }
  return (
    <Button asChild size="sm" className={`${cls} bg-[#25D366] text-slate-950 hover:bg-[#1fb857]`} data-testid={testid}>
      <a href={href} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} title="Abrir conversa no WhatsApp" aria-label="Abrir conversa no WhatsApp">
        <MessageCircle className="h-4 w-4" />{label}
      </a>
    </Button>
  );
};
